import React from "react";

const Circle = () => {
  return (
    <div className="hidden lg:block -z-10 w-big h-big -bottom-1/4 right-0 left-0 bg-indigo-900 rounded-full absolute mx-auto"></div>
  );
};

export default Circle;
